import {Injectable} from '@angular/core';
import {Observable} from "rxjs/Observable";
import {Push, PushObject, PushOptions} from "@ionic-native/push";
import {CONFIG} from "../app/config";
import {Util} from "../app/util";
import {DataService} from "./data-service";
import {StorageService} from "./storage-service";
import {Platform} from "ionic-angular";

@Injectable()
export class PushService {

    private pushObject: PushObject;

    public badge: number = 0;

    constructor(public push: Push, public util: Util, public platform: Platform,
                public dataService: DataService, public storageService: StorageService) {

        // usado para testar
        // web-push send-notification --endpoint=https://updates.push.services.mozilla.com/wpush/v1/gAAAAABap20DPtpLUUBADUgR7tT_D-__t34sPWT9MJM-qIZeeiF9WbPLnbfjqYxO_qKecpZ34CiFlZkhnVOwEKW2sXf7dnMD3UbKXwmPk6vlFH8EKrIH6QS39Y-ikb88N893KgpyrFeu --key=BE6DkcF3OefH9qJcnRyMimpHnn6yBKdzzu1g58kaifrU7csmBfMva_77SoJ6K2LTkba2mTw4a6yj5jbVW-ItS9U --auth=OgSDy9gbQCtTS6sJpkBgSg --payload="{\"message\":\"Você foi um dos sortudos a ganhar uma garrafa Smirnoff!\",\"title\":\"Parabéns!\",\"queryString\":\"?page-force=perfil\",\"tipoPush\":\"PUSH_ALERT\"}"

    }

    init(): Observable<any> {

        return Observable.create(observer => {

            const options: PushOptions = {
                ios: {alert: true, badge: true, sound: true},
                android: {senderID: CONFIG.spotus.Interface.gcm_id},
                windows: {},
                browser: {pushServiceURL: CONFIG.paths.pushBrowserApi}
            };

            this.pushObject = this.push.init(options);

            let errorbug = true;
            let errorany = {Titulo: 'NOTIFICAÇÃO', Result: '', Resolt: ''};

            this.pushObject.on('registration').subscribe(registration => {

                let registrationId = !registration ? '' : registration.registrationId;

                // Grava na memoria o pushid
                // para nao ficar pegando do BD toda hora.
                this.storageService.set('LOADED-NOTIFICA', true, true).subscribe();
                this.dataService.set('LOADED-NOTIFICA', true);

                CONFIG.data.device.DevicerPush = registrationId;

                errorbug = false;
                observer.next(registration);
                observer.complete();

            });

            this.pushObject.on('error').subscribe(erro => {

                errorbug = false;
                errorany.Result = 'Problemas para registrar o envio de notificações.';
                errorany.Resolt = erro.message;

                //XCode - Ativou em Capabilities o Push? NFC se usar também hein!
                observer.error(errorany);
                observer.complete();

            });

            /** ATENÇÃO - GAMBI RETURN  **/
            /** *********************** **/
            //Quando o push não retorno nada (ele não carrega o app)
            setTimeout(() => {

                if (errorbug) {

                    errorany.Result = 'Para voltar a receber notificações, ative manualmente e reinicie seu dispositivo.';
                    observer.error(errorany);
                    observer.complete();

                }

            }, 5000);

        });

    }

    clearAllNotifications(): Observable<any> {

        return Observable.create(observer => {

            this.pushObject.clearAllNotifications()
                .then(() => {

                    observer.next();
                    observer.complete();

                });

        });

    }

    setBadge(count: number) {

        if (!this.pushObject) return;

        this.pushObject.setApplicationIconBadgeNumber(count);

    }

    getPermission(): Observable<any> {

        return Observable.create(observer => {

            this.push.hasPermission()
                .then(permission => {

                    if (permission.isEnabled) {
                        observer.next();
                        observer.complete();
                    }
                    else {
                        observer.error({
                            Titulo: 'Ops!',
                            Result: 'Não temos permissão para enviar notificações.'
                        });
                        observer.complete();
                    }

                });

        });

    }


    pushStart(checkPermission: boolean): Observable<any> {

        return Observable.create(observer => {

            if (!this.platform.is('cordova')) {
                observer.next({});
                observer.complete();
                return;
            }

            let onInit = () => {

                //XCode - Ativou em Capabilities o Push? NFC se usar também hein!
                this.init()
                    .finally(() => observer.complete())
                    .subscribe(
                        registration => {

                            //CONFIG.data.device.DevicerPush = !registration ? '' : registration.registrationId;
                            this.pushListen().subscribe();
                            observer.next(registration);

                        },
                        erro => {

                            //this.util.alertResult(erro);
                            observer.error(erro);

                        });

            };

            if (!checkPermission) {
                onInit();
                return;
            }

            this.getPermission()
                .subscribe(
                    data => onInit(),
                    erro => {

                        observer.error(erro);
                        observer.complete();

                    });

        });

    }

    //Push Functions
    pushListen(): Observable<any> {

        return Observable.create(observer => {

            // quando app estiver aberto ou fechado
            // quando aba estiver aberta apenas
            // === se aba estiver fechada, navegação será via URL e não cai aqui ===
            this.pushObject.on('notification')
                .subscribe((notification: any) => {

                    //APP-PUBLISH
                    //if (notification.additionalData.foreground) {
                    (window as any).handappMainInstance.pushReceive(notification);
                    //    this.pushService.clearAllNotifications().subscribe(() => {});
                    //}

                    observer.next(notification);
                    ////observer.complete();

                });

        });

    }


}



// WEBPACK FOOTER //
// ./src/providers/push-service.ts